"use client";

import { type Context, createContext as reactCreateContext, use } from "react";

/**
 * A helper to create a Context and Provider with no upfront default value, and
 * without having to check for undefined all the time.
 */
export const createContext = <A extends unknown | null>(): readonly [() => A, Context<A | undefined>] => {
  const ctx = reactCreateContext<A | undefined>(undefined);

  const useCtx = () => {
    const c = use(ctx);
    if (c === undefined) {
      throw new Error("useCtx must be inside a Provider with a value");
    }
    return c;
  };

  return [useCtx, ctx];
};
